import { Controller } from "@hotwired/stimulus"

// Manages funerary plan adicionals nested attributes
export default class extends Controller {
  static targets = ["container", "template", "item", "destroy"]
  static values = {
    index: { type: Number, default: 0 }
  }

  add(event) {
    event.preventDefault()

    const template = this.templateTarget.innerHTML
    const index = this.indexValue
    this.indexValue = index + 1

    const newContent = template.replace(/NEW_INDEX/g, index)

    const wrapper = document.createElement("div")
    wrapper.innerHTML = newContent.trim()

    this.containerTarget.appendChild(wrapper.firstElementChild)
  }

  remove(event) {
    event.preventDefault()
    const item = event.target.closest("[data-funerary-adicionals-target='item']")

    if (item) {
      // Check if it has a destroy hidden field (existing record)
      const destroyField = item.querySelector("input[name*='_destroy']")

      if (destroyField) {
        destroyField.value = "1"
        item.classList.add("hidden")
      } else {
        item.remove()
      }
    }
  }
}
